module.exports = __webpack_public_path__ + "img/award-04.e73780b3.svg";